import { useEffect } from 'react';

import { PeerTypes, useListInfinitePeerRecentDonations } from '@givebacks/api/store';
import { Center, Loader, RecentDonation, Stack, Title } from 'ui';
import { useInViewport } from 'ui/Hooks';

const PeerRecentDonations = ({
  causeId,
  campaignId,
  uuid,
  peerType,
}: {
  causeId: string;
  campaignId: string;
  uuid: string;
  peerType: PeerTypes;
}) => {
  const { ref, inViewport } = useInViewport();

  const { data, hasNextPage, fetchNextPage, isFetchingNextPage, isInitialLoading } =
    useListInfinitePeerRecentDonations({ causeId, campaignId, uuid, peerType });

  useEffect(() => {
    if (inViewport && hasNextPage) fetchNextPage();
  }, [fetchNextPage, hasNextPage, inViewport]);

  const hasDonations = data && data?.pages[0].donations.length > 0;

  return (
    <Stack>
      {!isInitialLoading && hasDonations && (
        <>
          <Title order={2}>Recent Donations</Title>
          {data?.pages.map((page) =>
            page.donations.map((donation) => (
              <RecentDonation
                key={donation.uuid}
                status={donation.status}
                donorName={donation.name}
                date={donation.purchased_at}
                pledged={donation.pledged}
                total={donation.total}
                creditedTo={donation.participant_name ?? donation.credited_to_name}
              />
            ))
          )}
        </>
      )}
      <Center ref={ref}>{isFetchingNextPage && <Loader />}</Center>
    </Stack>
  );
};

export { PeerRecentDonations };
